import { EMPLOYMENT_TYPES } from 'cpool-constants';
import type { Schema_Beschaeftigung } from 'cpool-schemas';

const getDefaultOfficial = (): {
    beschaeftigung: Extract<Schema_Beschaeftigung, { beschaeftigungsart: typeof EMPLOYMENT_TYPES.BEAMTER }>;
} => ({
    beschaeftigung: {
        beamter: {
            beschaeftigungsverhaeltnis: {
                arbeitgeber: {
                    anschrift: {
                        hausnummer: null,
                        land: null,
                        ort: null,
                        plz: null,
                        strasse: null,
                    },
                    branche: null,
                    name: null,
                },
                berufsbezeichnung: null,
                beschaeftigtSeit: null,
                inProbezeit: null,
                inProbezeitBis: null,
                kumulierterJahreswert: null,
                nettoeinkommenMonatlich: null,
                nettoeinkommenVorletzterMonat: null,
                nettoeinkommenVorVorletzterMonat: null,
                verbeamtetSeit: null,
            },
        },
        beschaeftigungsart: EMPLOYMENT_TYPES.BEAMTER,
        steuerklasse: null,
    },
});
export default getDefaultOfficial;
